import { v1 as uuid } from "uuid";
import { OrderContentArticles } from "@Components/molecules/cart/CartOverviewTile/CartOrderContent";
import AddressesContent, { DeliveryMethod } from "@Types/addresses";
import { Currency, Price, PriceFormatted as PriceApi } from "@Types/api/price";
import CartContent, {
  Article,
  Country,
  FooterSection,
  Icon,
  Place,
  Placeholders,
} from "@Types/cart";
import CreditCard from "@Types/creditCard";
import { PriceFormatted } from "@Types/price";
import Promo from "@Types/promos";

export const currency: Currency = "EUR";

export const articles: Article[] = [
  {
    additionalOptions: [
      {
        name: undefined,
        optionValueTag: "gift",
        productOptionTag: "bag",
        quantity: 1,
        tag: "gift",
        total: { cents: 350, currency, formattedPrice: "3,50 €" },
      },
      {
        name: undefined,
        optionValueTag: "default",
        productOptionTag: "fairy_lights",
        quantity: 1,
        tag: "default",
        total: { cents: 800, currency, formattedPrice: "8 €" },
      },
      {
        name: undefined,
        optionValueTag: "peas",
        productOptionTag: "little_scrapbook",
        quantity: 1,
        tag: "peas",
        total: { cents: 1700, currency, formattedPrice: "17 €" },
      },
    ],
    contentDeviceTag: "web_app",
    createdDate: "2019-11-08T14:44:54.152+01:00",
    currency: "EUR",
    gift: false,
    id: 22106817,
    product: {
      articleBehaviorTag: "",
      deprecated: false,
      name: "Tirage photo in-contour-nable",
      outOfStock: false,
      priceCents: 700,
      productImage: {
        big: "https://staging1.cheerz.com/contents/assets/image-o3mF7cgAqBJCiDehcZPB6NJv-3x-1.jpg",
        medium:
          "https://staging1.cheerz.com/contents/assets/image-o3mF7cgAqBJCiDehcZPB6NJv-2x-1.jpg",
        small:
          "https://staging1.cheerz.com/contents/assets/image-o3mF7cgAqBJCiDehcZPB6NJv-1x-1.jpg",
      },
      skipSelection: true,
      statProductGroupTag: "prints",
      tag: "prints-mini-pack20",
      thumb: undefined,
    },
    quantity: 1,
    recovered: false,
    selectionContent: undefined,
    total: { cents: 3550, currency, formattedPrice: "35,50 €" },
    updatedDate: "2019-11-08T14:45:19.619+01:00",
  },
  {
    additionalOptions: [
      {
        name: undefined,
        optionValueTag: "gift",
        productOptionTag: "bag",
        quantity: 1,
        tag: "gift",
        total: { cents: 350, currency, formattedPrice: "3,50 €" },
      },
      {
        name: undefined,
        optionValueTag: "default",
        productOptionTag: "fairy_lights",
        quantity: 1,
        tag: "default",
        total: { cents: 800, currency, formattedPrice: "8 €" },
      },
      {
        name: undefined,
        optionValueTag: "peas",
        productOptionTag: "little_scrapbook",
        quantity: 1,
        tag: "peas",
        total: { cents: 1700, currency, formattedPrice: "17 €" },
      },
    ],
    contentDeviceTag: "web_app",
    createdDate: "2019-11-08T14:43:36.328+01:00",
    currency,
    gift: false,
    id: 22106816,
    product: {
      articleBehaviorTag: "",
      deprecated: false,
      name: "Tirage photo in-contour-nable",
      outOfStock: false,
      priceCents: 700,
      productImage: {
        big: "https://staging1.cheerz.com/contents/assets/image-o3mF7cgAqBJCiDehcZPB6NJv-3x-1.jpg",
        medium:
          "https://staging1.cheerz.com/contents/assets/image-o3mF7cgAqBJCiDehcZPB6NJv-2x-1.jpg",
        small:
          "https://staging1.cheerz.com/contents/assets/image-o3mF7cgAqBJCiDehcZPB6NJv-1x-1.jpg",
      },
      skipSelection: true,
      statProductGroupTag: "prints",
      tag: "prints-mini-pack20",
      thumb: undefined,
    },
    quantity: 1,
    recovered: false,
    selectionContent: undefined,
    total: { cents: 3550, currency, formattedPrice: "35,50 €" },
    updatedDate: "2019-11-08T14:44:02.125+01:00",
  },
];

export const cart: CartContent = {
  articles,
  cartModifiers: [
    {
      articles: [
        {
          id: 22106817,
          quantity: 2,
        },
        {
          id: 22106816,
          quantity: 2,
        },
      ],
      discountRate: 20,
      tag: "double",
      totalWithDiscount: { cents: 11360, currency, formattedPrice: "113,60 €" },
      totalWithoutDiscount: { cents: 14200, currency, formattedPrice: "142 €" },
    },
  ],
  currency,
  deliveryDates: ["2019-11-29T00:00:00.000+01:00", "2019-12-03T00:00:00.000+01:00"],
  giftNote: {
    available: false,
    content: undefined,
  },
  lockedDuringPayment: false,
  orderNumber: "CZ27568910",
  promoCode: undefined,
  promoTotal: { cents: 0, currency, formattedPrice: "0 €" },
  revenue: 5916,
  shippable: true,
  shippingOptions: {
    home: {
      express: {
        available: true,
        deliveryDates: undefined,
        price: {
          cents: 990,
          currency,
          formattedPrice: "9.90€",
        },
        selected: false,
      },
      normal: {
        available: true,
        deliveryDates: ["2019-11-29T12:00:00.000+01:00", "2019-12-03T12:00:00.000+01:00"],
        price: { cents: 390, currency, formattedPrice: "3.90€" },
        selected: true,
      },
    },
    mondialRelay: {
      express: {
        available: false,
        deliveryDates: undefined,
        price: undefined,
        selected: false,
      },
      normal: {
        available: true,
        deliveryDates: ["2019-11-29T12:00:00.000+01:00", "2019-12-03T12:00:00.000+01:00"],
        price: { cents: 390, currency, formattedPrice: "3.90€" },
        selected: false,
      },
    },
  },
  shippingTotal: { cents: 390, currency, formattedPrice: "3.90€" },
  subTotal: { cents: 7100, currency, formattedPrice: "71 €" },
  tax: 1184,
  total: { cents: 7490, currency, formattedPrice: "74.90 €" },
};

export const price: Price = { cents: 1100, currency };

export const formattedPriceApi: PriceApi = {
  cents: -1100,
  currency,
  formatted_price: "-11,00 €",
};

export const formattedPrice: PriceFormatted = { ...price, formattedPrice: "11,00 €" };

export const bannerTexts: string[] = [
  "Add 2 Calendars to your cart and get 15% discount with the code CALENDAR2",
  "15% off all products when you spend £80 or more",
  "Add 3 Calendars to your cart and get 20% discount with the code CALENDAR3",
];

export const promos: Promo[] = [
  {
    code: "CALENDAR2",
    description:
      "Ajoutez 2 calendriers à votre panier et bénéficiez de 15% de réduction avec le code CALENDAR2 😉 (hors frais de port)",
    priority: 4,
    title: "Pack 2 Calendriers",
  },
  {
    code: "CHEERZ80",
    description: "15% offerts sur le total de votre commande dès 80€ d'achat (hors frais de port)",
    priority: 2,
    title: "15% offerts",
  },
];

export const promoCode = "PROMOCODE";

export const promoCodeErrorMessage =
  "Code promo non valide, veuillez vérifier la date de validité et réessayer";

export const promoCodeContent = {
  promoCode: "HAMNOPRINT",
};

export const promoCodeJsonSample = {
  promo_code: "HAMNOPRINT",
};

export const promoCodeErrorResponse = {
  error: "unprocessable_entity",
  error_description: [promoCodeErrorMessage],
};

export const failPromoCodeSample = {
  error: {
    description: promoCodeErrorMessage,
    type: "unprocessable_entity",
  },
};

// TODO: modify when you refacto the component which uses it

export const paymentLogos: string[] = [
  "https://cdn2.chrzz.com/assets/images/cart/footer/cb-6a812aa4.png",
  "https://cdn2.chrzz.com/assets/images/cart/footer/mastercard-f993d7d1.png",
  "https://cdn2.chrzz.com/assets/images/cart/footer/paypal-b5e6f4d0.png",
  "https://cdn2.chrzz.com/assets/images/cart/footer/visa-c66ca566.png",
];

export const packagingLogos: string[] = [
  "https://cdn2.chrzz.com/assets/images/cart/footer/gift-d4940111.png",
];

export const deliveryLogos: string[] = [
  "https://cdn2.chrzz.com/assets/images/cart/footer/dhl-ecd7a56f.png",
  "https://cdn2.chrzz.com/assets/images/cart/footer/yodel-28b52705.png",
  "https://cdn2.chrzz.com/assets/images/cart/footer/royal_air_mail-8c045ed2.png",
];

export const satisfactionGuaranteeLogos: string[] = [
  "https://cdn2.chrzz.com/assets/images/cart/footer/diduenjoy-418a3c2a.png",
];

export const footerSections: FooterSection[] = [
  {
    description:
      "Payment is 100% secure and encrypted with SSL and TLS protocols for completely secure data transmission. 🔒",
    id: 1,
    link: {
      href: "https://support.cheerz.com/hc/en-us/sections/203722598-Payment-and-security",
      text: "More info",
    },
    logos: paymentLogos,
    title: "Secured payment",
  },
  {
    additionalInfo: "PS : you may even find some surprises inside ;)",
    description:
      "Our products are shipped in special packaging to ensure their protection during transport.",
    id: 2,
    logos: packagingLogos,
    title: "Packaging",
  },
  {
    description: "For fast and efficient delivery, we use the best couriers possible!",
    id: 3,
    link: {
      href: "https://support.cheerz.com/hc/en-us/categories/115001947647-Delivery",
      text: "More info",
    },
    logos: deliveryLogos,
    title: "Delivery",
  },
  {
    additionalInfo: "97% of our customer are satisfied! ",
    description:
      "(Statistic taken from more than 30,000 reviews collected in 2016 via a DidUEnjoy satisfaction survey)",
    id: 4,
    logos: satisfactionGuaranteeLogos,
    title: "Satisfaction guarantee",
  },
];

export const countries: Country[] = [
  {
    name: "Andorra",
    tag: "AD",
    tagAlpha3: "AND",
  },
  {
    name: "Argentina",
    tag: "AR",
    tagAlpha3: "ARG",
  },
  {
    name: "Australia",
    tag: "AU",
    tagAlpha3: "AUS",
  },
  {
    name: "Austria",
    tag: "AT",
    tagAlpha3: "AUT",
  },
  {
    name: "Belgium",
    tag: "BE",
    tagAlpha3: "BEL",
  },
  {
    name: "Brazil",
    tag: "BR",
    tagAlpha3: "BRA",
  },
  {
    name: "Canada",
    tag: "CA",
    tagAlpha3: "CAN",
  },
  {
    name: "Chile",
    tag: "CL",
    tagAlpha3: "CHL",
  },
  {
    name: "China",
    tag: "CN",
    tagAlpha3: "CHN",
  },
  {
    name: "Colombia",
    tag: "CO",
    tagAlpha3: "COL",
  },
  {
    name: "Czech Republic",
    tag: "CZ",
    tagAlpha3: "CZE",
  },
  {
    name: "Denmark",
    tag: "DK",
    tagAlpha3: "DNK",
  },
  {
    name: "Estonia",
    tag: "EE",
    tagAlpha3: "EST",
  },
  {
    name: "Finland",
    tag: "FI",
    tagAlpha3: "FIN",
  },
  {
    name: "France",
    tag: "FR",
    tagAlpha3: "FRA",
  },
  {
    name: "Germany",
    tag: "DE",
    tagAlpha3: "DEU",
  },
  {
    name: "Greece",
    tag: "GR",
    tagAlpha3: "GRC",
  },
  {
    name: "Hong Kong",
    tag: "HK",
    tagAlpha3: "HKG",
  },
  {
    name: "Hungary",
    tag: "HU",
    tagAlpha3: "HUN",
  },
  {
    name: "Ireland",
    tag: "IE",
    tagAlpha3: "IRL",
  },
  {
    name: "Italy",
    tag: "IT",
    tagAlpha3: "ITA",
  },
  {
    name: "Luxembourg",
    tag: "LU",
    tagAlpha3: "LUX",
  },
  {
    name: "Malta",
    tag: "MT",
    tagAlpha3: "MLT",
  },
  {
    name: "Mexico",
    tag: "MX",
    tagAlpha3: "MEX",
  },
  {
    name: "Monaco",
    tag: "MC",
    tagAlpha3: "MCO",
  },
  {
    name: "Morocco",
    tag: "MA",
    tagAlpha3: "MAR",
  },
  {
    name: "Netherlands",
    tag: "NL",
    tagAlpha3: "NLD",
  },
  {
    name: "New Zealand",
    tag: "NZ",
    tagAlpha3: "NZL",
  },
  {
    name: "Norway",
    tag: "NO",
    tagAlpha3: "NOR",
  },
  {
    name: "Poland",
    tag: "PL",
    tagAlpha3: "POL",
  },
  {
    name: "Portugal",
    tag: "PT",
    tagAlpha3: "PRT",
  },
  {
    name: "Qatar",
    tag: "QA",
    tagAlpha3: "QAT",
  },
  {
    name: "Romania",
    tag: "RO",
    tagAlpha3: "ROU",
  },
  {
    name: "Singapore",
    tag: "SG",
    tagAlpha3: "SGP",
  },
  {
    name: "Slovakia",
    tag: "SK",
    tagAlpha3: "SVK",
  },
  {
    name: "Slovenia",
    tag: "SI",
    tagAlpha3: "SVN",
  },
  {
    name: "South Africa",
    tag: "ZA",
    tagAlpha3: "ZAF",
  },
  {
    name: "Spain",
    tag: "ES",
    tagAlpha3: "ESP",
  },
  {
    name: "Sweden",
    tag: "SE",
    tagAlpha3: "SWE",
  },
  {
    name: "Switzerland",
    tag: "CH",
    tagAlpha3: "CHE",
  },
  {
    name: "Thailand",
    tag: "TH",
    tagAlpha3: "THA",
  },
  {
    name: "Turkey",
    tag: "TR",
    tagAlpha3: "TUR",
  },
  {
    name: "United Arab Emirates",
    tag: "AE",
    tagAlpha3: "ARE",
  },
  {
    name: "United Kingdom",
    tag: "GB",
    tagAlpha3: "GBR",
  },
  {
    name: "United States",
    tag: "US",
    tagAlpha3: "USA",
  },
];

export const deliverAddressIcon: Icon = {
  description: "Delivery address",
  url: "https://cdn2.chrzz.com/assets/images/cart/checkout/icon-address-fad7b441.svg",
};

export const billingAddressIcon: Icon = {
  description: "Billing address",
  url: "https://cdn2.chrzz.com/assets/images/cart/checkout/icon-billing-dd530772.svg",
};

export const addresses: Place[] = [
  {
    fullName: "NC, USA",
    id: uuid(),
    placeName: "Asheville",
    value: "Asheville, NC, USA",
  },
  {
    fullName: "",
    id: uuid(),
    placeName: "Asia",
    value: "Asia",
  },
  {
    fullName: "CO, USA",
    id: uuid(),
    placeName: "Aspen",
    value: "Aspen, CO, USA",
  },
  {
    fullName: "Notherlands",
    id: uuid(),
    placeName: "Aspen",
    value: "Assen, Notherlands",
  },
];

export const fakeAddresses: Place[] = [
  {
    fullName: "NC, USA",
    id: uuid(),
    placeName: "Asheville",
    value: "Asheville, NC, USA",
  },
  {
    fullName: "",
    id: uuid(),
    placeName: "Asia",
    value: "Asia",
  },
  {
    fullName: "CO, USA",
    id: uuid(),
    placeName: "Aspen",
    value: "Aspen, CO, USA",
  },
  {
    fullName: "Notherlands",
    id: uuid(),
    placeName: "Aspen",
    value: "Assen, Notherlands",
  },
  {
    fullName: "Notherlands",
    id: uuid(),
    placeName: "Aspen",
    value: "Assen, Notherlands",
  },
];

export const placeholders: Placeholders = {
  firstName: "First Name",
  lastName: "Last Name",

  company: "Company name (optional)",

  street: "Address (n° and street name)",

  details: "Additional details (Apartment n°, entrance code..)",
  postcode: "Postcode",

  city: "City",
  country: "Country",

  phone: "Phone number",

  email: "Email",
  tvaNumber: "TVA number (optional)",
};

export const address: AddressesContent = {
  billing: {
    city: "Paris",
    company: "Cheerz",
    country: "France",
    countryTag: "FRA",
    countryTag2: "FR",
    details: "4e étage",
    firstName: "Pierre",
    lastName: "Touron",
    postcode: "75008",
    state: undefined,
    street: "7 rue de bucarest",
    tvaNumber: "22222",
  },
  delivery: {
    city: "Paris",
    company: "Cheerz",
    country: "France",
    countryTag: "FRA",
    countryTag2: "FR",
    details: "4e étage",
    email: "pierre@cheerz.com",
    firstName: "Pierre",
    lastName: "Touron",
    mondialRelayNumber: "014050",
    phone: "0505050505",
    postcode: "75008",
    shippingOptions: {
      express: {
        available: true,
        deliveryDates: ["2019-12-19T12:00:00.000+01:00", "2019-12-20T12:00:00.000+01:00"],
        price: {
          cents: 990,
          currency: "EUR",
          formattedPrice: "9,90 €",
        },
        selected: false,
      },
      mondialRelay: {
        express: {
          available: false,
          deliveryDates: undefined,
          price: undefined,
          selected: false,
        },
        normal: {
          available: true,
          deliveryDates: ["2019-12-26T12:00:00.000+01:00", "2019-12-27T12:00:00.000+01:00"],
          price: {
            cents: 390,
            currency: "EUR",
            formattedPrice: "3,90 €",
          },
          selected: false,
        },
      },
      normal: {
        available: true,
        deliveryDates: ["2019-12-26T12:00:00.000+01:00", "2019-12-27T12:00:00.000+01:00"],
        price: {
          cents: 390,
          currency: "EUR",
          formattedPrice: "3,90 €",
        },
        selected: true,
      },
    },
    state: undefined,
    street: "7 rue de bucarest",
    tag: "home",
    userCountryTag: "FRA",
  },
  user: {
    temporaryEmail: "pierre@cheerz.com",
  },
};

export const shippingOptions = {
  home: {
    express: {
      available: true,
      deliveryDates: undefined,
      price: {
        cents: 990,
        currency,
        formattedPrice: "9.90€",
      },
      selected: false,
    },
    normal: {
      available: true,
      deliveryDates: ["2019-11-29T12:00:00.000+01:00", "2019-12-03T12:00:00.000+01:00"],
      price: {
        cents: 390,
        currency,
        formattedPrice: "3.90€",
      },
      selected: true,
    },
  },
  mondialRelay: {
    express: {
      available: false,
      deliveryDates: undefined,
      price: undefined,
      selected: false,
    },
    normal: {
      available: true,
      deliveryDates: ["2019-11-29T12:00:00.000+01:00", "2019-12-03T12:00:00.000+01:00"],
      price: {
        cents: 390,
        currency,
        formattedPrice: "3.90€",
      },
      selected: false,
    },
  },
};

export const deliveryMethods: DeliveryMethod[] = [
  {
    deliveryModes: shippingOptions.home,
    logo: "home_delivery.png",
    name: "home",
    selected: true,
  },
  {
    deliveryModes: shippingOptions.mondialRelay,
    logo: "mondial_relay.png",
    name: "mondialRelay",
    selected: false,
  },
];

export const orderContentArticles: OrderContentArticles[] = [
  {
    name: "Big Scrapbook",
    quantity: 1,
    total: {
      cents: 4000,
      currency: "EUR",
      formattedPrice: "€40",
    },
  },
  {
    name: "Hardcover Photo Album 21x21cm",
    quantity: 7,
    total: {
      cents: 17500,
      currency: "EUR",
      formattedPrice: "€175",
    },
  },
  {
    name: "Magnet Hearts",
    quantity: 1,
    total: {
      cents: 200,
      currency: "EUR",
      formattedPrice: "€2",
    },
  },
  {
    name: "Magnet Hearts",
    quantity: 1,
    total: {
      cents: 200,
      currency: "EUR",
      formattedPrice: "€2",
    },
  },
];

export const creditCard: CreditCard = {
  cardType: "visa",
  identifier: "7500",
  month: 2,
  year: 2022,
};

export const deliveryDates = ["2019-12-23T00:00:00.000+01:00", "2019-12-24T00:00:00.000+01:00"];
